module.exports = __webpack_public_path__ + "img/image106.ffda7aee.png";